// extracted by mini-css-extract-plugin
export default {"emptyContainer":"EmptyContainer_emptyContainer__sCpH3","focusIconContainer":"EmptyContainer_focusIconContainer__yLgHQ","focusIcon":"EmptyContainer_focusIcon__DaNA5"};